 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		94: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		94: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + {"0":"0dd8f65","1":"ff77c43","2":"3a1420d","3":"c17c4e7","4":"55ed82d","5":"91cd9ce","6":"942b56c","7":"f9e53ac","10":"ce3ba2d","11":"f5da159","12":"375d3e2","13":"0068719","14":"d4b2c57","15":"25a46f2","16":"7d4befe","17":"7c503de","18":"e405206","19":"c4e495e","20":"f4b3900","21":"d1da7c4","22":"c023d5b","23":"324530c","24":"aa97f44","25":"03219b2","26":"c8ab45e","27":"bc0b564","28":"ef75718","29":"dc792a0","30":"420b859","31":"5877447","32":"d236de4","33":"1ec7e6d","34":"b9dd981","35":"081836a","36":"9cb3b2a","37":"c920d3a","38":"c3dba05","39":"f06bad7","40":"2ce9c86","41":"8a7b69d","42":"8865375","43":"5a541ff","44":"5f3aa06","45":"c22116f","46":"ac0c4c6","47":"35d33c5","48":"76a7b72","49":"48185ca","50":"aa86abd","51":"6cf9f19","52":"1576bda","53":"8a1792c","54":"e8f0163","55":"1cdc5b2","56":"31ebb4a","57":"8ca5ccc","58":"f8f7c13","59":"ea3a8fe","60":"a7f9563","61":"321dafa","62":"05a70ea","63":"afc45c9","64":"18de399","65":"fa0fd68","66":"dc5da75","67":"a393813","68":"8c30576","69":"a514ddb","70":"e3dca48","71":"6dfd1f1","72":"db8a321","73":"400cc05","74":"194d965","75":"06edf9b","76":"ab33195","77":"83f139f","78":"b7dad65","79":"bd697a7","80":"c9962fb","81":"adbab8f","82":"f30ae78","83":"181ebba","84":"2d0587f","85":"b920437","86":"4001035","87":"1bace83","88":"9d89a08","89":"48dcbe4","90":"1eecba2","91":"347c3bb","92":"e72b577","93":"069561f","96":"55cf49a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// extract-css-chunks-webpack-plugin CSS loading
 		var supportsPreload = (function() { try { return document.createElement("link").relList.supports("preload"); } catch(e) { return false; }}());
 		var linkExists = false
 		var cssChunks = {"0":1,"4":1,"5":1,"6":1,"7":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"27":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"35":1,"36":1,"37":1,"38":1,"39":1,"40":1,"41":1,"42":1,"43":1,"44":1,"45":1,"46":1,"47":1,"48":1,"49":1,"50":1,"51":1,"52":1,"53":1,"54":1,"55":1,"56":1,"57":1,"58":1,"59":1,"60":1,"61":1,"62":1,"64":1,"65":1,"66":1,"67":1,"74":1,"75":1,"76":1,"77":1,"78":1,"79":1,"80":1,"81":1,"82":1,"83":1,"84":1,"85":1,"86":1,"87":1,"88":1,"89":1,"90":1,"91":1,"92":1,"93":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + {"0":"0adfd3d","1":"31d6cfe","2":"31d6cfe","3":"31d6cfe","4":"9eb4bb5","5":"34b0e51","6":"f053ea8","7":"7d4d8b8","10":"658f6dd","11":"ceacc5e","12":"c737dd3","13":"bb9b919","14":"7523d59","15":"602e5f0","16":"13853ed","17":"9eb4bb5","18":"6d6b4de","19":"7fd8fe6","20":"1559c09","21":"ba2437f","22":"2aa63b4","23":"70533cf","24":"8d91688","25":"31d6cfe","26":"31d6cfe","27":"7c69435","28":"af614bf","29":"bfc04be","30":"6444c0a","31":"8591be3","32":"0adfd3d","33":"e0f8d33","34":"604043a","35":"1965dc3","36":"a6eb623","37":"008124a","38":"ad8013b","39":"415b069","40":"3585ab9","41":"266d35d","42":"dd0bcd2","43":"eb35154","44":"91e0c0b","45":"6b9d781","46":"7d8f8fe","47":"7d8f8fe","48":"3e50d15","49":"bf4e1e4","50":"1732363","51":"3a15aa5","52":"6175004","53":"e82f9c9","54":"23e6631","55":"e84d0ae","56":"75ccdb4","57":"93b2cfd","58":"58a06cb","59":"1458819","60":"ed2dce5","61":"d670c19","62":"f70c11e","63":"31d6cfe","64":"0a48d98","65":"faf7755","66":"5724d47","67":"f4b68d5","68":"31d6cfe","69":"31d6cfe","70":"31d6cfe","71":"31d6cfe","72":"31d6cfe","73":"31d6cfe","74":"d33c07d","75":"d33c07d","76":"d33c07d","77":"d33c07d","78":"d33c07d","79":"d33c07d","80":"d33c07d","81":"d33c07d","82":"d33c07d","83":"d33c07d","84":"d33c07d","85":"d33c07d","86":"d33c07d","87":"38db853","88":"d33c07d","89":"d89de31","90":"d33c07d","91":"d33c07d","92":"d33c07d","93":"d33c07d","96":"31d6cfe"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if((tag.rel === "stylesheet" || tag.rel === "preload") && (dataHref === href || dataHref === fullhref)) {
 						linkExists = true
 						return resolve();
 					}
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = supportsPreload ? "preload": "stylesheet";
 				supportsPreload ? linkTag.as = "style" : linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0]; head.appendChild(linkTag)
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 				if(!linkExists && supportsPreload) {
 					var execLinkTag = document.createElement("link");
 					execLinkTag.href =  __webpack_require__.p + "css/" + {"0":"0adfd3d","1":"31d6cfe","2":"31d6cfe","3":"31d6cfe","4":"9eb4bb5","5":"34b0e51","6":"f053ea8","7":"7d4d8b8","10":"658f6dd","11":"ceacc5e","12":"c737dd3","13":"bb9b919","14":"7523d59","15":"602e5f0","16":"13853ed","17":"9eb4bb5","18":"6d6b4de","19":"7fd8fe6","20":"1559c09","21":"ba2437f","22":"2aa63b4","23":"70533cf","24":"8d91688","25":"31d6cfe","26":"31d6cfe","27":"7c69435","28":"af614bf","29":"bfc04be","30":"6444c0a","31":"8591be3","32":"0adfd3d","33":"e0f8d33","34":"604043a","35":"1965dc3","36":"a6eb623","37":"008124a","38":"ad8013b","39":"415b069","40":"3585ab9","41":"266d35d","42":"dd0bcd2","43":"eb35154","44":"91e0c0b","45":"6b9d781","46":"7d8f8fe","47":"7d8f8fe","48":"3e50d15","49":"bf4e1e4","50":"1732363","51":"3a15aa5","52":"6175004","53":"e82f9c9","54":"23e6631","55":"e84d0ae","56":"75ccdb4","57":"93b2cfd","58":"58a06cb","59":"1458819","60":"ed2dce5","61":"d670c19","62":"f70c11e","63":"31d6cfe","64":"0a48d98","65":"faf7755","66":"5724d47","67":"f4b68d5","68":"31d6cfe","69":"31d6cfe","70":"31d6cfe","71":"31d6cfe","72":"31d6cfe","73":"31d6cfe","74":"d33c07d","75":"d33c07d","76":"d33c07d","77":"d33c07d","78":"d33c07d","79":"d33c07d","80":"d33c07d","81":"d33c07d","82":"d33c07d","83":"d33c07d","84":"d33c07d","85":"d33c07d","86":"d33c07d","87":"38db853","88":"d33c07d","89":"d89de31","90":"d33c07d","91":"d33c07d","92":"d33c07d","93":"d33c07d","96":"31d6cfe"}[chunkId] + ".css";
 					execLinkTag.rel = "stylesheet";
 					execLinkTag.type = "text/css";
 					document.body.appendChild(execLinkTag);
 				}
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/static/app-hotmart-legal/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
